import React, { useEffect, useState, useContext } from "react";
import MaterialTable from "material-table";
import AuthContext from "../../context/autentication/authContext";
import Titulo2 from "../Dialog/Titulo2";

import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { ALERT_STATUS } from "types/alertadispositivo/index";


export default function TablaPolicial({ logs, refresh, setCurrent }) {
  const [open, setOpen] = React.useState(false);
  const [misLogs, setMisLogs] = useState(logs);
  const [option, setOption] = useState("");
  const [index, setIndex] = useState();
  const authContext = useContext(AuthContext);
  const { rol } = authContext;

  const [lista, setLista] = useState([]);

  const ordenarDatos = (data) => {
    console.log("-->", data);

    const resultado = data.map((x, index) => {
      return {
        fecha: x.auditoriaActivacion.split("T", 2)[0],
        hora: x.auditoriaActivacion.split("T", 2)[1].split(".", 2)[0],
        estado: x.estado,
        dispositivo: x.dispositivo,
        index: index,
        original: x,
      };
    });
    return resultado;
  };
  useEffect(() => {
    setLista(ordenarDatos(misLogs));
    return () => {
      setMisLogs([]);
    };
  }, [logs]);
  const handleClose = () => {
    setIndex();
    setOpen(false);
  };

  return (
    <div style={{ minHeight: "100%", maxHeight: "100%" }}>
      <MaterialTable
        title={<Titulo2 titulo={" "} />}
        options={{
          search: false,
          exportButton: false,
          actionsColumnIndex: -1,
          maxBodyHeight: "47vh",
          minBodyHeight: "47vh",
          pageSize: 20,
          pageSizeOptions: [20, 50, 100],
        }}
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} de {count}",
            labelRowsSelect: "filas",
            firstTooltip: "Primer Pág",
            lastTooltip: "Última Pág",
            nextTooltip: "Prox Pág",
            previousTooltip: "Anterior Pág",
          },
          toolbar: {},
          header: {
            actions: <p style={{width:"150px"}}>Marcar como vista</p>
          },
          body: {
            emptyDataSourceMessage: "No se encontraron registros",
          },
        }}
        columns={[
          { title: "Fecha", field: "fecha" },
          { title: "Hora", field: "hora" },
        ]}
        data={lista}
        editable={[]}
        actions={[
          (rowData) => ({
            icon: () =>
              rowData.estado !== ALERT_STATUS.VISTA && rowData.estado !== ALERT_STATUS.VISTAPOLICIA ? (
                <MdVisibility style={{ color: "#DF2E2E"}} />
              ) : (
                <MdVisibility/>
              ),
            tooltip: "marcar como vista",
            onClick: () => setCurrent({ rowData, lista, rol }),
          }),
        ]}
      />
      <div></div>
    </div>
  );
}
